import { render, staticRenderFns } from "./SectorDetails.vue?vue&type=template&id=ec8f63f8"
import script from "./SectorDetails.vue?vue&type=script&lang=js"
export * from "./SectorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports